module.exports = __webpack_public_path__ + "img/logoFull.b239042e.svg";